import { createRoute, getPathForAllPortals } from "utilities/flatRoutes/routes";

export const preliminaryEstimatePath = "/PreliminaryEstimate";
export const preliminaryEstimateRoute = createRoute(
    getPathForAllPortals(preliminaryEstimatePath),
    "Preliminary Estimates",
);

export const preliminaryEstimateGeneratePath = "/PreliminaryEstimate/Generate";
export const preliminaryEstimateGenerateRoute = createRoute(
    getPathForAllPortals(preliminaryEstimateGeneratePath),
    "Preliminary Estimate",
);

interface IPreliminaryEstimateDetailParams {
    /** The estimate's externalID — stable across stores, unlike the identity key. */
    id: string;
}

// Registered after the Generate route in App.tsx: this path matches /PreliminaryEstimate/Generate
// too, so that ordering is what keeps it from shadowing the generate page.
export const preliminaryEstimateDetailPath = "/PreliminaryEstimate/:id";
export const preliminaryEstimateDetailRoute = createRoute<IPreliminaryEstimateDetailParams>(
    getPathForAllPortals(preliminaryEstimateDetailPath),
    "Preliminary Estimate",
);
